import { SettingsGroup, SettingsPageFrame } from '@eluve/blocks';
import { AppGrantsSettings } from '@eluve/frontend-feature-user-settings';
import { useTranslation } from '@eluve/i18n';

export const AppGrantsSettingsPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <SettingsPageFrame title={t('settings.nav.appGrants')}>
      <SettingsGroup
        title={t('settings.appGrants.authorizedAgents')}
        description={t('settings.appGrants.authorizedAgentsDescription')}
      >
        <AppGrantsSettings />
      </SettingsGroup>
    </SettingsPageFrame>
  );
};
